import { Button } from 'component/Button/Button'
import { Modal } from 'component/Modal/Modal'
import { Space } from 'component/Space/Space'
import { Spinner } from 'component/Spinner'
import { Typo } from 'component/Typo/Typo'
import { Vertical } from 'component/Vertical/Vertical'
import { i18n } from 'i18n/i18n'
import { ReactNode } from 'react'
import css from './ConfirmModal.module.scss'

interface ConfirmModalProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  title?: string
  message?: ReactNode
  confirmText?: string
  cancelText?: string
  confirmVariant?: 'primary' | 'danger' | 'warning'
  loading?: boolean
}

export const ConfirmModal = ({
                               open,
                               onClose,
                               onConfirm,
                               title,
                               message,
                               confirmText = i18n('confirm.Confirm'),
                               cancelText = i18n('confirm.Cancel'),
                               confirmVariant = 'primary',
                               loading = false,
                             }: ConfirmModalProps) => {
  const handleConfirm = () => {
    if (!loading) {
      onConfirm()
    }
  }

  const handleClose = () => {
    if (!loading) {
      onClose()
    }
  }

  return (
    <Modal open={open} onCancel={handleClose} width={400} closeButton={false}>
      <Vertical className={css.container} gap={24} pad={24}>
        <Vertical gap={16}>
          {title && (
            <Typo size={16} weight={600}>
              {title}
            </Typo>
          )}
          {message && (
            <Typo size={14} secondary pre center>
              {message}
            </Typo>
          )}
        </Vertical>

        <Space gap={12} wide columns>
          <Button text wide action={handleClose} disabled={loading}>
            {cancelText}
          </Button>
          <Button
            wide
            action={handleConfirm}
            disabled={loading}
            primary={confirmVariant === 'primary'}
            danger={confirmVariant === 'danger'}
          >
            {loading ? <Spinner /> : confirmText}
          </Button>
        </Space>
      </Vertical>
    </Modal>
  )
}
